/**
 * description: 微博流程记录查看
 * author: Qian.qianchen 2018-11-20
 */
'use strict';
angular.module('weiboProcessRecordModule', []).controller('weiboProcessRecordCtrl', [
    '$scope',
    '$modalInstance',
    'item',
    'trsHttpService',
    'initVersionService',
    function($scope, $modalInstance, item, trsHttpService, initVersionService) {
        initStatus();
        requestData();

        /**
         * [initStatus description] 初始化状态值
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    serviceid: 'wcm61_socialprocess',
                    methodname: 'queryToJson',
                    objType: item.MEDIATYPE || 5,
                    ObjId: item.SCMMICROCONTENTID,
                },
            };
            $scope.data = {
                records: [],
                operationLog: [],
                mediaType: {
                    '5': '微博',
                    '17': '抖音',
                    '18': '百家号',
                    '19': '企鹅号',
                },
            };
        }

        /**
         * [requestData description] 请求流程记录
         * @return  {[type]}  [return description]
         */
        function requestData() {
            $scope.data.mediaName = $scope.data.mediaType[item.MEDIATYPE] || '微博';
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWeiboRootUrl(), $scope.status.params, 'post').then(function(data) {
                if (Object.prototype.toString.call(data) == '[object Array]') {
                    $scope.data.records = initVersionService.getDayContent(data, 'push').concat($scope.data.records);
                }
            });
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
